<div id="page-container">
  <div id="content-wrap">
    <!-- <vc-poll-pages-header [title]="title" [isLive]="isLive" [isPublic]="isPublic"
    [SMSOption]="isSms" [is2FA]="is2FA" [isAssessors]="hasAssessorsButtons"></vc-poll-pages-header> -->
    <vc-poll-overview-header [title]="title" [isLive]="isLive" [isPublic]="isPublic" [SMSOption]="isSms" [is2FA]="is2FA"
      [isAssessors]="hasAssessorsButtons" [image]="image"></vc-poll-overview-header>
    <vc-poll-planned-countdown [timeDelta]="timeDifference" [timeDiffHours]="remainingTime" [title]="title"
      (shouldLaunchConvocations)="displayConvocationPopup()" [canSendConvocations]="canSendConvocation"
      [canResendAssessors]="canResendAssessors" [remainingAssessorTime]="remainingAssessorTime"
      (shouldRelaunchAssessors)="relaunchAssessors()" [hasAssessorsButtons]="hasAssessorsButtons"
      (shouldGetAssessors)="displayAssessors()" [inactiveAssessors]="remainingAssessors" [assessorCount]="assessors">
    </vc-poll-planned-countdown>

    <div class="info-blue flex content-center">
      <p id="exclamation">!</p> Scrutin validé le {{formatDate(creationDate)}}
    </div>

    <p-panel>
      <p class="text-md dark-blue"><img src="assets/calendar25.svg" style="margin-right: 10px;" class="icon-inline">
        Période du scrutin : du {{startDate}} au {{endDate}}</p>
      <p class="text-md dark-blue"><img width="18px" id="silhouette" style="margin-right: 10px;"
          src="assets/silhouette_icon_black.svg">Invités au scrutin : <span class="bold">{{votersCount}}</span></p>
    </p-panel>

    <div class="custom-accordion-container light-border" *ngIf="description && description.trim() !== ''">
      <div class="custom-accordion-item" (click)="toggleDescription()">
        <p class="text-md dark-blue custom-description" [class.expanded]="isDescriptionExpanded">
          {{isDescriptionExpanded ? description : getTruncatedDescription()}}
        </p>
        <i class="pi pi-chevron-down custom-arrow" [class.rotated]="isDescriptionExpanded"></i>
      </div>
    </div>

    <div *ngIf="!isLive" class="grid-col-2 items-center default-bloc" style="margin-top: 35px;">

      <div style="text-align: center;">

        <div *ngIf="votingType != 'list'">
          <ng-container *ngIf="canSendConvocation; else elseBlock">
            <button class="action-button pointer" (click)=displayConvocationPopup() style=" width: 284px;">
              {{'TIMER.CONVOCATIONS' | translate}}
            </button>
          </ng-container>
          <ng-template #elseBlock>
            <button class="gap-10 disabled-action-button flex align-items-center content-center"><img class="clock-icon"
                width="20px" src="assets/clock.svg">
              <p class="w-three-quarters text-left">{{'POLL-PLANNED.RESEND-TIME' | translate}} <span
                  class="bold">{{remainingTime}}</span></p>
            </button>
            <div *ngIf="remainingTime != null" class="clock-holder">

            </div>
          </ng-template>
        </div>
        <div *ngIf="votingType == 'list'">
          <ng-container *ngIf="remainingAssessors == 0; else unsealedBlock">
            <button class="action-button pointer" (click)=downloadSealingReport() style=" width: 284px;">
              Télécharger le PV de scellement
            </button>
          </ng-container>
          <ng-template #unsealedBlock>
            <div class="tooltip-wrapper">
              <button class="iconless-disabled-action-button not-allowed" style="width: 284px;">
                Télécharger le PV de scellement
              </button>
              <span class="custom-tooltip">Action requise : tous les assesseurs doivent avoir saisi leur clé.</span>
            </div>
          </ng-template>
        </div>

      </div>

      <button *ngIf="hasAssessorsButtons == true" class="action-button pointer"
        (click)=displayAssessors()>{{'TIMER.ASS-LISTE' |
        translate}}</button>
    </div>

    <div *ngIf="votingType == 'resolution' || votingType == 'live'">
      <vc-poll-planned-list class="resolutions" [votingType]="votingType" [answers]="answers"
        (editionEventEmitter)="editPoll()" [shouldEdit]="true">
      </vc-poll-planned-list>
    </div>
    <div *ngIf="votingType == 'election'">
      <!-- Condition should edit a revoir potentiellement -->
      <!-- numberOfVote -->
      <vc-poll-planned-list *ngFor="let candidat of candidates, let index = index" class="election"
        [votingType]="votingType" [candidates]="candidat" [answers]="answers[0]"
        [numberOfVote]="answers[0].numberOfVote" (editionEventEmitter)="editPoll()"
        [shouldEdit]="answers[0].displayedQuestions.length <= 1" [index]="index">
      </vc-poll-planned-list>
    </div>
    <div *ngIf="votingType == 'list'" class="grid-col-2 form-holder">
      <!-- <vc-poll-planned-list *ngFor="let list of lists" class="election" [votingType]="votingType" [titles]="titles"
        [answers]="list" [numberOfVote]="list.numberOfVote" (editionEventEmitter)="editPoll()" [shouldEdit]="false">
      </vc-poll-planned-list> -->
      <vc-poll-list *ngFor="let list of lists, let round = index" class="list" [votingType]="votingType"
        [answers]="list" [numberOfVote]="list.numberOfVote" (editionEventEmitter)="editPoll()" [titles]="titles"
        [pollId]="pollId" [displayBlockchain]="true" [index]="round">
      </vc-poll-list>

    </div>
    <div *ngIf="isLive && canResend"
      style="width: 700px; margin: auto; display: flex; justify-content: center; padding-top: 24px;">
      <button *ngIf="isLive" class="action-button"
        (click)="displayEarlyLaunchWarning()">{{'POLL-CREATION.CONFIRMATION.LAUNCH-POLL-LIVE' | translate}}</button>
    </div>
    <div style="width: 700px; margin: auto; display: flex; justify-content: center; padding-top: 24px;">
      <button class="action-button dark-blue pointer" (click)="returnToDraft()">Retour à la configuration du
        scrutin</button>
    </div>

  </div>
</div>
<div *ngIf="isError">
  <app-error (isClosed)="common.navigateToPolls()" [errorMessage]="errorMessage">
  </app-error>
</div>
<div *ngIf="shouldDisplayConvocationWarning">
  <app-convocation-popup (isClosed)="handleConvocations($event)" [isResend]=false>
  </app-convocation-popup>
</div>
<div *ngIf="shouldAssessorConvocationWarning">
  <assessors-relaunch-popup (isClosed)="launchAssessorsRelaunch($event)" [isResend]=false [isAssessors]=true>
  </assessors-relaunch-popup>
</div>

<div *ngIf="singleAssessorsRelaunchPopup">
  <single-assessors-relaunch-popup (isClosed)="launchSingleAssessorsRelaunch($event)" [isResend]=false [isAssessors]=true
  [assessorToRelaunch]="assessorToRelaunch">
  </single-assessors-relaunch-popup>
</div>

<div *ngIf="shouldDisplayAssessors">
  <assessors-list-popup (endDetailsPopup)="dismiss1Assessors()" (relaunchSingleAssessorEvent)="relaunchSingleAssessor($event)"
    [mails]="inactiveAssessors" (updateAssessorEvent)="showChangeAssessors($event)" [canResendAssessors]="canResendAssessors"
    [remainingAssessorTime]="remainingAssessorTime" [allAssessors]="allAssessors">
  </assessors-list-popup>
</div>
<div *ngIf="shouldDisplayLaunchWarning">
  <vc-warning-popup
    title="Cette action annulera votre paramétrage d'envoi programmé des liens de connexions au site de vote, êtes-vous sûr de vouloir confirmer ?"
    [confirmButton]="true" (endDetailsPopup)="dismissLaunch($event)" [separator]="false">
  </vc-warning-popup>
</div>
<div *ngIf="displayChangeAssessor">
  <transfer-assessors-popup [pollId]="pollId" [mailToChange]="assessorToUpdate"
    (closeChangeAssessor)="closeChangeAssessor($event)"></transfer-assessors-popup>
  <!-- <app-assessor-change-component [pollId]="pollId"
    (closeChangeAssessor)="closeChangeAssessor($event)"></app-assessor-change-component> -->
</div>
<div *ngIf="shouldDisplayChangeAssessorValidation">
  <app-valid-voter-changes (close)="closeChangeValidation()"></app-valid-voter-changes>
  <!-- <app-valid-changes (close)="closeChangeValidation()"></app-valid-changes> -->
</div>